import { create } from "zustand";
import type { Verdict } from "@/domain/learning/model/verdict";

/**
 * 現在の演習・判定結果・開示済みヒント数を保持するストア。
 *
 * NFR-002 のための規則: 更新は判定結果が変わった時のみであり高頻度ではないが、
 * 利用側はストア全体ではなくセレクタで必要な値のみを購読すること。
 */
export interface DrillStore {
  readonly currentDrillId: string | null;
  readonly verdict: Verdict | null;
  readonly revealedHintCount: number;
  readonly setCurrentDrillId: (drillId: string | null) => void;
  readonly setVerdict: (verdict: Verdict | null) => void;
  readonly setRevealedHintCount: (count: number) => void;
}

export const useDrillStore = create<DrillStore>((set) => ({
  currentDrillId: null,
  verdict: null,
  revealedHintCount: 0,
  setCurrentDrillId: (drillId) => set({ currentDrillId: drillId }),
  setVerdict: (verdict) => set({ verdict }),
  setRevealedHintCount: (count) => set({ revealedHintCount: count }),
}));
